import React, {useState, useEffect} from "react"

import {ValidateInput} from "../../utilities"
import "./style.css";

function CustomizedCheckBox(props) {
    const {
        label,
        liste_valeurs,
        name,
        required,
        error,
        schema
    } = props

    const [isValid, setIsValid] = useState(!error)
    const [isChecked, setIsChecked] = useState(false)

    const validateInput = (e) => {
        setIsChecked(e.target.checked)
        const valid = ValidateInput(schema, { [name]: e.target.value })
        setIsValid(valid)
    }

    useEffect(() => {
        setIsValid(!error)
    }, [error])

    const option = liste_valeurs.split(";")

    return <div className={`form-group form-element justify-content-between ${!isValid ? "error" : ""}`}>
        <div>
            <label htmlFor={name}>{label} {required ? <span className='text-danger'>*</span> : null}</label>
        </div>
        <div id={name}>
            {option.map(o => {
                return <div key={o} className="checkbox-container">
                    <input name={name} type="checkbox" value={o} id={`${name}-${o}`} onChange={validateInput} />
                    <label className="form-check-label" htmlFor={`${name}-${o}`}>
                        {o}
                    </label>
                    {!isChecked ? <input type="hidden" name={name} value={""} /> : null}
                </div>
            })}
        </div>
    </div>
}

export default CustomizedCheckBox;